import React from 'react';
import ReactECharts from 'echarts-for-react';

const LineChart = ({ option }) => {
  return <ReactECharts option={option} />;
};

export default LineChart;
